import { adminHttpClient } from "../../../../commons/adminHttpClinet";
import { GetMarketplaceModel, MarketplaceModel, MarketplaceSearch } from "../../../../models/dashboard/marketplace/affiliatesModel";

const getAllMarketplaces = (deleted:boolean):Promise<Array<MarketplaceModel>> => {
    return adminHttpClient.get(`/api/Admin/AdminMarketplace/get-all-marketplaces?IsDeleted=${deleted}`);
}

export default getAllMarketplaces;